<form [formGroup]="busqueda">
    <nav class="navbar navbar-light bg-light navbar-expand-lg mb-3">
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto">
            <!-- Lista de Meses -->
            <li class="nav-item me-2">
                <select id="mesesFormControl" class="form-select" formControlName="mesesFormControl"
                    ngbTooltip="Seleccione el mes a filtrar." (change)="this.onChange($event)">
                    <option [value]="null" disabled defaultselected>Seleccione un mes...</option>
                    <option *ngFor="let m of keysMeses()" [ngValue]="m">
                        {{ m }}
                    </option>
                </select>        
            </li>
            <!-- Año -->
            <li class="nav-item me-2">
                <input type="number" formControlName="anioFormControl" class="form-control" style="width: 100px;">        
            </li>
            <!-- Lista de Productos -->
            <li class="nav-item me-2">
                <select id="productoFormControl" class="form-select" formControlName="productoFormControl"
                    ngbTooltip="Seleccione el producto a filtrar.">
                    <option [value]="null" disabled defaultselected>Seleccione un producto...</option>
                    <option *ngFor="let p of this.productos" [ngValue]="p.codigoProducto">
                        {{ p.nombreProducto }}
                    </option>
                </select>
                <loading-text-spinner *ngIf="this.cargandoProductos" 
                    message="Obteniendo productos..." color="primary">
                </loading-text-spinner>
            </li>
            <!-- Boton Consultar -->
            <li class="nav-item">
                <button                                
                    [disabled]="busqueda.invalid"
                    class="btn btn-primary my-2 my-lg-0 mx-lg-2"
                    (click)="filtrarMovimientos()"><i class="fa fa-search" aria-hidden="true"></i>
                </button>
            </li>
          </ul>
          <ul class="navbar-nav">
            <!-- Boton Generacion --> 
            <li class="nav-item">
                <button *ngIf="!this.generada && this.resolucionMensual"
                    [disabled]="grabando || busqueda.invalid" style="float: right;"
                    (click)="this.generarResolucion()" 
                    type="button" class="btn btn-primary my-2 my-lg-0 mx-lg-2">
                        Generar Informe
                    <div *ngIf="grabando" class="spinner-border text-primary spinner-border-sm" role="status"></div>
                </button>
                <button *ngIf="this.resolucionMensual && this.generada"
                [disabled]="grabando || busqueda.invalid" style="float: right;"
                (click)="this.verResolucion()" 
                type="button" class="btn btn-primary my-2 my-lg-0 mx-lg-2">
                    Ver Informe
                <div *ngIf="grabando" class="spinner-border text-primary spinner-border-sm" role="status"></div>
            </button>
            </li>   
          </ul>
        </div>
    </nav>
</form>    

<div class="col container-fluid">
    
    <div class="spinner-container" *ngIf="obteniendoResolucion">
        <ngx-spinner name="spinnerGrafico" bdOpacity=0.3bd
            Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
            <p style="color: white"> C o n s u l t a n d o . . . </p>
        </ngx-spinner>
    </div>

    <ngb-alert [dismissible]="false"
        *ngIf="!obteniendoResolucion && this.resolucionMensual?.renglonesResolucion!=null && this.resolucionMensual?.renglonesResolucion.length==0">
        No existe información para la busqueda seleccionada
    </ngb-alert>
    
    <table class="table table-striped" *ngIf="!obteniendoResolucion && this.resolucionMensual?.renglonesResolucion!=null && this.resolucionMensual?.renglonesResolucion.length > 0">
        <thead class="text-center">
            <th class="primerNivel">Código Dependencia</th>
            <th class="primerNivel">Dependencia Origen</th>
            <th class="primerNivel">Fecha Ult Cierre</th>
            <th class="segundoNivel">Existencia Inicial</th>
            <th class="segundoNivel">Entradas</th>
            <th class="segundoNivel">Salidas</th>
            <th class="segundoNivel">Existencia Libros</th>
            <th class="segundoNivel">Existencia Final</th>
            <th class="tercerNivel">Removido [lt]</th>
            <th class="tercerNivel">Sup / Déf [lt]</th>
            <th class="tercerNivel">Porcentual [%]</th>
            <th class="tercerNivel">Tolerancia M.O. [%]</th>
            <th class="tercerNivel">Resultado</th>
            <th class="tercerNivel">% FT</th>
        </thead>        
        <tbody *ngIf="this.resolucionMensual.renglonesResolucion!=null">                
            <tr *ngFor="let r of this.resolucionMensual.renglonesResolucion; let i=index">          
                <td class="primerNivel text-center">{{r.codigoAeroplanta}}</td>                                      
                <td class="primerNivel text-center">{{r.nombreAeroplanta}}</td>                                     
                <td class="primerNivel text-center">{{r.fechaUltimoCierre | date:'dd/MM/yyyy hh:mm a'}}</td>                                     
                <td class="segundoNivel text-center">{{r.existenciaInicial}}</td>                                     
                <td class="segundoNivel text-center">{{r.entradas}}</td>                                     
                <td class="segundoNivel text-center">{{r.salidas}}</td>                                     
                <td class="segundoNivel text-center">{{r.existenciaInicial + r.entradas - r.salidas}}</td>                                     
                <td class="segundoNivel text-center">{{r.existenciaFinal}}</td>                                     
                <td class="tercerNivel text-center">{{r.removido}}</td>
                <td class="tercerNivel text-center">{{r.supDef | number:'0.2-2'}}</td>                                     
                <td class="tercerNivel text-center">{{r.porc | number:'0.2-3'}}%</td>                                     
                <td class="tercerNivel text-center">{{r.toleranciaMensualOperativa | number:'0.2-3'}}%</td>                                     
                <td [ngClass]="[r.resultado=='FT' ? 'colorRojo' : 'colorVerde']"
                    class="text-center">{{r.resultado }}</td>                                     
                <td class="tercerNivel text-center">{{r.ft | number:'0.2-2'}}%</td>                                  
            </tr>             
        </tbody>                                
    </table>
</div>